class SearchDrawer {
    constructor() {
        this.searchDrawer = document.querySelector('.search-drawer');
        if (document.querySelector('.search-drawer__overlay')) document.querySelector('.search-drawer__overlay').addEventListener("click", this.close.bind(this));
        if (document.querySelector('.search-drawer__close-btn')) document.querySelector('.search-drawer__close-btn').addEventListener("click", this.close.bind(this));
        if (document.querySelector('.header__search')) document.querySelector('.header__search').addEventListener("click", this.open.bind(this));
    }

    close() {
        this.searchDrawer.classList.remove('active');
        document.body.classList.remove('lock');
    }

    open() {
        this.searchDrawer.classList.add('active');
        document.body.classList.add('lock');
    }
}

if (!document.querySelector('.snize-results-page')) {
    const searchDrawer = new SearchDrawer()

    if (document.querySelector('.search-block')) {
        
            document.querySelector('.search-block .search-form__btn').addEventListener("click", e => {
                e.preventDefault();
                searchDrawer.open();
                const predictiveSearch = document.querySelector('predictive-search');
                predictiveSearch.onFormSubmit();
            })   
        
    }
}

if (document.querySelector('.snize-results-page')) {
    if (document.querySelector('.header__search')) {
        document.querySelector('.header__search').addEventListener("click", () => {
            console.log(document.querySelector('.search-block .search-form__input'));
            
            if (document.querySelector('.search-block .search-form__input')) {
                document.querySelector('.search-block .search-form__input').focus();
            }
        })
    }
}
